"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _tabbable = require("tabbable");
var _events = require("../../utils/events");
var _excluded = ["enabled", "wrapWithDiv", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * When it receives a boolean prop enabled, PreventFocus blocks users from navigating via the
 * keyboard or screenreader to its children.  Its intended use is with interactive widgets such as
 * modals, in which the area 'covered' by the modal is not supposed to be discoverable while the
 * modal is open. In this case, wrap PreventFocus around the area(s) visually covered by the modal
 * window.
 *
 * Notes:
 * This was created due to limitations of libraries like react-focus-lock and focus-trap-react
 * which at this time they have one major A11y limitation: They don't prevent screen readers from
 * navigating to items that are tabbable outside the focus trap/loop.
 *
 * One way to prevent screen readers from navigating to all the child tabbable elements would be
 * add tabindex="-1" to them.  But this isn't easy to implement in React.  That's why we took this
 * route instead.
 */

var PreventFocus = function PreventFocus(props) {
  // The lastBlurred isn't tracked via setState because it’s unnecessary and if it were it would be
  // extremely inefficient.  This is because anytime any element looses focus (that different to the
  // previous one) all of children of the all the PreventFocus components would be re-rendered. :p
  var lastBlurred;
  var rootNodeRef = (0, _react.useRef)();
  var handleDocumentBlur = function handleDocumentBlur(e) {
    lastBlurred = e.target;
  };
  (0, _react.useEffect)(function () {
    (0, _events.addEventListener)(document, 'blur', handleDocumentBlur, true);
    return function () {
      return (0, _events.removeEventListener)(document, 'blur', handleDocumentBlur, true);
    };
  }, []);
  var setFocusOutside = function setFocusOutside(_ref) {
    var forward = _ref.forward,
      tabbables = _ref.tabbables,
      targetIndex = _ref.targetIndex;
    var startIndex = forward ? targetIndex + 1 : targetIndex - 1;

    // Search for the next tabbable node outside this componenent
    var _loop = function _loop() {
        var _rootNodeRef$current, _rootNodeRef$current$;
        var item = tabbables[i];
        if (!(rootNodeRef !== null && rootNodeRef !== void 0 && (_rootNodeRef$current = rootNodeRef.current) !== null && _rootNodeRef$current !== void 0 && (_rootNodeRef$current$ = _rootNodeRef$current.contains) !== null && _rootNodeRef$current$ !== void 0 && _rootNodeRef$current$.call(_rootNodeRef$current, item))) {
          // Perform focus in a requestAnimationFrame so that browser has time to
          // update last blurred item. Otherwise, it's possible to get into an infinite
          // loop when multiple PreventFocus components are present on a page as the browser
          // hasn't accounted for the last blurred item yet and attempts to focus on the same
          // element again (causing PreventFocus to handle focus for that element again, ad infinitum).
          window.requestAnimationFrame(function () {
            item.focus();
          });
          return {
            v: void 0
          };
        }
      },
      _ret;
    for (var i = startIndex; i < tabbables.length && i >= 0; forward ? i++ : i--) {
      _ret = _loop();
      if (_ret) return _ret.v;
    }

    // If we made it this far there are no more focusable items in this direction,
    // so we reset focus to the document body.
    window.requestAnimationFrame(function () {
      document.body.setAttribute('tabindex', '-1');
      document.body.focus();
      document.body.setAttribute('tabindex', '');
    });
  };
  var handleFocus = function handleFocus(e) {
    var tabbables = (0, _tabbable.tabbable)(document.body);
    var lastBlurredIndex = tabbables.indexOf(lastBlurred);
    var targetIndex = tabbables.indexOf(e.target);
    setFocusOutside({
      tabbables: tabbables,
      targetIndex: targetIndex,
      forward: lastBlurredIndex < targetIndex
    });
  };
  var focusProps = {
    'aria-hidden': true,
    onFocus: handleFocus,
    ref: rootNodeRef
  };
  var enabled = props.enabled,
    wrapWithDiv = props.wrapWithDiv,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (!enabled) {
    return wrapWithDiv ? /*#__PURE__*/_react["default"].createElement("div", otherProps, _react.Children.only(children)) : _react.Children.only(children);
  }
  return wrapWithDiv ? /*#__PURE__*/_react["default"].createElement("div", _extends({}, otherProps, focusProps), _react.Children.only(children)) : (/*#__PURE__*/(0, _react.cloneElement)(_react.Children.only(children), focusProps));
};
PreventFocus.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A single child element or React Component for PreventFocus to wrap.
   */
  children: _propTypes["default"].any.isRequired,
  /**
   * Flag indicating whether child elements within this component should be inert and not allow focus.
   */
  enabled: _propTypes["default"].bool.isRequired,
  /**
   * Flag indicating whether to wrap the child of this component with a div (including focus
   * management props). This is useful when the child of this component ignores extra props,
   * like `ReactTransitionGroup`.
   */
  wrapWithDiv: _propTypes["default"].bool.isRequired
} : {};
PreventFocus.defaultProps = {
  enabled: true,
  wrapWithDiv: true
};
var _default = exports["default"] = PreventFocus;